function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Manager, Reference } from 'react-popper';
import { deprecatedPropType } from 'pcln-design-system';
import PopoverContent from '../PopoverContent';

var Popover = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);
    _this.state = {
      isPopoverOpen: props.openOnMount
    };
    _this.contentRef = /*#__PURE__*/React.createRef();
    _this.triggerRef = /*#__PURE__*/React.createRef();
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.setFocusToRef = _this.setFocusToRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Popover, [{
    key: "handleToggle",
    value: function handleToggle(evt, isOpen) {
      evt.preventDefault();
      evt.stopPropagation();

      if (isOpen) {
        this.handleClose();
      } else {
        this.handleOpen();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this2 = this;

      this.setState({
        isPopoverOpen: false
      }, function () {
        _this2.setFocusToRef(_this2.triggerRef);
      });
      this.props.onClose && this.props.onClose();
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this3 = this;

      this.setState({
        isPopoverOpen: true
      }, function () {
        _this3.setFocusToRef(_this3.contentRef);
      });
      this.props.onOpen && this.props.onOpen();
    }
  }, {
    key: "setFocusToRef",
    value: function setFocusToRef(ref) {
      try {
        ref.current.focus({
          preventScroll: true
        });
      } catch (_unused) {
        // We need to be safe in case the ref is invalid, which will unmount component

        /*istanbul ignore next*/
        return false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var isOpenState = this.state.isPopoverOpen;
      var _this$props = this.props,
          ariaLabel = _this$props.ariaLabel,
          children = _this$props.children,
          isOpenProp = _this$props.isOpen;
      var isPopoverOpen = isOpenState || isOpenProp;
      return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref) {
        var ref = _ref.ref;
        return (
          /*#__PURE__*/
          // Need to be a native element, because of ref forwarding limitations with DS functional components
          React.createElement(InlineContainer, {
            ref: ref
          },
          /*#__PURE__*/
          // Clone element to pass down toggle event so it can be used directly from children as needed
          React.cloneElement(children, {
            'aria-label': ariaLabel,
            onClick: function onClick(evt) {
              return _this4.handleToggle(evt, isPopoverOpen);
            },
            ref: _this4.triggerRef
          }))
        );
      }), isPopoverOpen && /*#__PURE__*/React.createElement(PopoverContent, _extends({}, this.props, {
        onCloseRequest: this.handleClose,
        contentRef: this.contentRef
      })));
    }
  }]);

  return Popover;
}(Component);

var InlineContainer = styled.div.withConfig({
  displayName: "Popover__InlineContainer",
  componentId: "sc-1u2cycp-0"
})(["display:inline-block;"]);
Popover.propTypes = {
  idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  // ID needs to be required for A11y purposes. We need to uniquely identify each popover on screen
  renderContent: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  p: PropTypes.number,
  color: PropTypes.string,
  bg: deprecatedPropType('color'),
  borderColor: PropTypes.string,
  placement: PropTypes.string,
  zIndex: PropTypes.number,
  width: PropTypes.number,
  overlayOpacity: PropTypes.number,
  trapFocus: PropTypes.bool,
  isOpen: PropTypes.bool,
  openOnMount: PropTypes.bool,
  children: PropTypes.node,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  hideArrow: PropTypes.bool,
  hideOverlay: PropTypes.bool
};
Popover.defaultProps = {
  ariaLabel: 'Click to open popover with more information'
};
export default Popover;